import StageMessageStep from './StageMessageStep.component';

export default StageMessageStep;
